import { useSelector } from 'react-redux'

export const getIsDPMonthlySettlementEnabled = state =>
  state.payment.isDPMonthlySettlementEnabled

export const useIsDPMonthlySettlementEnabled = () => {
  return useSelector(state => state.payment.isDPMonthlySettlementEnabled)
}

export const getIsTPMonthlySettlementEnabled = state =>
  state.payment.isTPMonthlySettlementEnabled

export const useIsTPMonthlySettlementEnabled = () => {
  return useSelector(state => state.payment.isTPMonthlySettlementEnabled)
}
